export default "__VITE_ASSET__70638503__"